import React, { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { Link } from "react-router-dom";

export const CampusMessDetails = () => {
  useEffect(() => {
    AOS.init();
  }, []);

  return (
    <>
      <div>
        {/* Start Page Banner */}
        <div className="page-banner-area bg-1">
          <div className="container">
            <div className="page-banner-content">
              <h1>Campus Mess</h1>
              <ul>
                <li>
                  <Link to="/">Home</Link>
                </li>
                <li className="navspace">
                  <Link to="/campus">Campus</Link>
                </li>
                <li className="navspace">Mess </li>
              </ul>
            </div>
          </div>
        </div>
        {/* End Page Banner */}

        {/* <!--Start Academic Details Area--> */}
        <div className="academics-details-area pt-100 pb-70">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="academics-details">
                  <div className="details">
                    <h2>Healthy Eating at the Mess</h2>
                    <p>
                      A well-balanced diet is essential for sustaining energy
                      and health, especially when eating at a mess.
                      Nutrition-packed meals can fuel your body and mind
                      throughout the day.
                    </p>

                    <div className="details-images">
                      <div className="row">
                        <div className="col-lg-4 col-md-4">
                          <img
                            src="assets/images/campus-detail/mess-1.webp"
                            alt="Image"
                             width={416}
                            height={277}
                          />
                        </div>
                        <div className="col-lg-4 col-md-4">
                          <img
                            src="assets/images/campus-detail/mess-2.webp"
                            alt="Image"
                           width={416}
                            height={277}
                          />
                        </div>
                        <div className="col-lg-4 col-md-4">
                          <img
                            src="assets/images/campus-detail/mess-4.0.jpeg"
                            alt="Image"
                            width={416}
                            height={277}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="prepare-exam">
                    <h3>Optimizing Your Mess Menu for Better Health</h3>
                    <p>
                      Designing a mess menu with nutritious, well-balanced
                      options helps everyone maintain a healthy lifestyle. By
                      incorporating a variety of food groups, you ensure that
                      meals are both satisfying and nourishing.
                    </p>
                    <div className="row">
                      <div className="col-lg-6 col-md-6">
                        <div className="exam-card">
                          <h4> Balanced Meal Options</h4>
                          <p>
                            At the mess, choose meals with a good mix of
                            protein, carbs, and healthy fats to ensure your body
                            gets the nutrients it needs for energy and repair.
                          </p>
                        </div>
                      </div>
                      <div className="col-lg-6 col-md-6">
                        <div className="exam-card">
                          <h4>Managing Portion Sizes</h4>
                          <p>
                            Mindful eating is crucial when dining at the mess.
                            Pay attention to portion sizes to avoid overeating
                            while ensuring you get the right amount of calories.
                          </p>
                        </div>
                      </div>
                      <div className="col-lg-6 col-md-6">
                        <div className="exam-card">
                          <h4>Healthy Snacks and Drinks</h4>
                          <p>
                            Instead of sugary snacks and sodas, opt for fruits,
                            nuts, and water. These provide natural energy and
                            hydration without the unhealthy additives.
                          </p>
                        </div>
                      </div>
                      <div className="col-lg-6 col-md-6">
                        <div className="exam-card">
                          <h4>Special Dietary Needs</h4>
                          <p>
                            The mess should cater to various dietary needs, such
                            as vegetarian, vegan, or gluten-free options, to
                            accommodate all individuals and ensure proper
                            nutrition for everyone.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <!--End Academic Details Area--> */}
      </div>
    </>
  );
};
